package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class StatusDto(
    val status: String,
    val version: String,
    val timestamp: String
)
